export const environment = {
  production: false,
  API_URL: "https://apiv22.billex.pe",
  EXCHANGE_NAME: 'dev'
};
